import { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import api from "@/lib/api";

const CategoriesContext = createContext(null);

export function CategoriesProvider({ children }) {
  const { data } = useQuery({
    queryKey: ["categories"],
    queryFn: () => api.get("/categories").then((r) => r.data),
    staleTime: 5 * 60 * 1000,
  });

  const categories = data || [];
  const byName = (name) => categories.find((c) => c.name === name);
  const bySlug = (slug) => categories.find((c) => c.slug === slug);

  return (
    <CategoriesContext.Provider value={{ categories, byName, bySlug }}>
      {children}
    </CategoriesContext.Provider>
  );
}

export function useCategories() {
  return (
    useContext(CategoriesContext) || {
      categories: [],
      byName: () => undefined,
      bySlug: () => undefined,
    }
  );
}
